import { render, staticRenderFns } from "./PreviewTosModal.vue?vue&type=template&id=69720079&"
import script from "./PreviewTosModal.vue?vue&type=script&lang=js&"
export * from "./PreviewTosModal.vue?vue&type=script&lang=js&"
import style0 from "./PreviewTosModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports